import { useGlobalConfigContext } from '../../../global-config'
import { TENANT } from '../../../tenant'

/*
 * For tenants besides COM, we want to use a different style for the product page.
 * The radio button buy box and the tiles buy box look different.
 */
export const useProductPageRebrushStyle = (): boolean => {
  const { tenant } = useGlobalConfigContext()

  return TENANT.COM !== tenant
}
